export default __webpack_public_path__ + "neighborhood.png?76980e181e3c20d1a83ea54ac4b1f26b";